import React, { Suspense, useContext, useEffect } from "react";
import { Sidenav } from "../../../components/sidenav/Sidenav";
import {
  Outlet,
  useLocation,
  useParams,
  useNavigate,
  Navigate,
} from "react-router-dom";
import "./styles.css";
import { CircularProgress, Grid } from "@mui/material";
import Header from "../../../components/header/Header";
import RouteContext from "../../../utils/context/RouteContext";

export const Layout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (pathname === "/") {
    navigate("/dashboard");
  }

  return (
    <>
      <Grid className="layout-wrapper">
        <Suspense
          fallback={
            <div
              style={{
                position: "absolute",
                display: "grid",
                height: "100vh",
                width: "100%",
                placeItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          }
        >
          <Sidenav />
          <div
            style={{
              flex: "1",
              backgroundColor: "#f7f7f7",
            }}
          >
            <Outlet />
          </div>
        </Suspense>
      </Grid>
    </>
  );
};
